<template>
  <v-container fluid class="tour-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
              <v-btn to="/tour/add" color="success" class="button-shadow mr-3">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Add
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="tours-table"
              show-select
              single-select
              item-key="_id"
              :footer-props="footer"
              :headers="headers"
              :items="[
                ...tours.filter(item=>item.tourstatus=='Review'), 
                ...tours.filter(item=>item.tourstatus=='Active'), 
                ...tours.filter(item=>item.tourstatus=='New'), 
                ...tours.filter(item=>item.tourstatus=='Inactive')
              ]"
              :items-per-page="itemPerPage"
              >
              <template v-slot:top>
                <v-dialog
                  v-model="dialog"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Tour?
                    </v-card-title>

                    <v-card-text>
                      {{ deletetour.tourname }}
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="dialog = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteTour(deletetour)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.image="{ item }">
                <img v-if="item.tourimage" v-bind:src="item.tourimage" alt="" width="80">
              </template>
              <template v-slot:item.tourname="{ item }">
                <a class="primaryConst--text">{{ item.tourname }}</a>
              </template>
              <template v-slot:item.vendorid="{ item }">
                <p v-if="vendors.find(vendor=>vendor._id == item.vendorid)!=null">{{ vendors.length>0 ? vendors.find(vendor=>vendor._id == item.vendorid)['vendorname'] : ''  }}</p>
              </template>
              <template v-slot:item.countryid="{ item }">
                {{ countries.length>0 && countries.find(country=>country._id == item.countryid)!=null ? countries.find(country=>country._id == item.countryid)['countryname'] : ''  }}
              </template>
              <template v-slot:item.tourstatus="{ item }">
                <v-chip
                  small
                  :color="getStatusColor(item.tourstatus)"
                >
                  {{ item.tourstatus }}
                </v-chip>
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ new Date(item.createdAt).toLocaleString("en-US", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn icon color="primary" @click="editTour(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn v-if="['Active'].indexOf(item.tourstatus)==-1" icon color="primary" @click="deleteDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { getStatusColor } from '@/util/tools';

export default {
  name: 'TourList',
  data() {
    return {
      snackbar: null,
      dialog: false,
      deletetour: {},
      headers: [
        { text: 'Image', value: 'image', sortable: false },
        { text: 'Name', value: 'tourname' },
        { text: 'Type', value: 'tourtype' },
        { text: 'Vendor', value: 'vendorid' },
        { text: 'Country', value: 'countryid' },
        { text: 'Status', value: 'tourstatus' },
        { text: 'Create', value: 'createdAt' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      footer: {'items-per-page-options': [500, 1000, 5000]},
      itemPerPage: 100,
      selected: [],
      getStatusColor: getStatusColor,
    }
  },

  computed: {
    ...mapState('Tour', ['tours', 'isReceiving', 'isDeleting', 'idToDelete', 'toursMessage', 'isUpdating']),
    ...mapState('Country', ['countries']),
    ...mapState('Vendor', ['vendors']),
  },
  methods: {
    ...mapActions('Tour', ["getToursRequest","deleteTourRequest","updateTourRequest","createTourRequest"]),
    ...mapActions('Country', ["getCountriesRequest"]),
    ...mapActions('Vendor', ["getVendorsRequest"]),
    editTour(item) {
      this.$router.push({ name: 'TourEdit', params: item })
    },
    deleteTour(item) {
      this.deleteTourRequest({_id: item._id});
      this.dialog = false;
    },
    deleteDialog(item) {
      this.dialog = true;
      this.deletetour = {
        _id: item._id,
        tourname: item.tourname,
      }
    },

  },
  async created(){
    await this.getToursRequest();
    if(this.vendors.length==0) await this.getVendorsRequest();
    if(this.countries.length==0) await this.getCountriesRequest();
  }
}
</script>

<style src="./List.scss" lang="scss"></style>
